/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { and, isArchivedFilter } from './data'

interface Tooltip {
  IsArchived: boolean
  ItemCreated: null | string
  ItemCreatedBy: null | string
  ItemModified : null | string
  ItemModifiedBy : null | string
  TooltipDescription: string
  TooltipID: string
  TooltipName: string
  eKey: string
  eTag: string
}
interface TooltipFetchArgs {
  isArchived: false | null | true
}
const COLUMN_NAMES = {
  EKey: 'eKey',
  ETag: 'eTag',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByDisplayName: 'ItemCreatedBy/persona',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByDisplayName: 'ItemModifiedBy/persona',
  TooltipDescription: 'TooltipDescription',
  TooltipID: 'TooltipID',
  TooltipName: 'TooltipName',
}
const LIST_NAME = 'TooltipMetadataList'

const constructTooltipFilter = (args: TooltipFetchArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchived ?? null))
  const filter = and(...filters)
  return filter
}
const getTooltips = async (args: TooltipFetchArgs): Promise<Tooltip[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructTooltipFilter(args)
  const items: any = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.TooltipDescription,
      COLUMN_NAMES.TooltipID,
      COLUMN_NAMES.TooltipName,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.ItemCreatedByDisplayName,
      COLUMN_NAMES.ItemModifiedByDisplayName
    )
    .get()
  return [...items] as Tooltip[]
}
const addOrUpdateTooltips = async (addObj): Promise<void> => {
  try {
    const andList = await mpfRListsHttp().getList(LIST_NAME)
    await andList.addOrUpdateItem(addObj)
  } catch (error) {
    console.error(error)
  }
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type Tooltip,
  type TooltipFetchArgs,
  addOrUpdateTooltips,
  getTooltips,
}
